var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenShareOnButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15456",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15456",
    transform: "translate(-447 -910)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9447",
    "data-name": "\\u9577\\u65B9\\u5F62 9447",
    width: 92,
    height: 92,
    transform: "translate(447 910)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20977",
    "data-name": "\\u30D1\\u30B9 20977",
    d: "M165.771,292.4H152.628a9.856,9.856,0,0,1-9.857-9.857V239.832a9.857,9.857,0,0,1,9.857-9.857h72.286a9.856,9.856,0,0,1,9.857,9.857v42.714a9.856,9.856,0,0,1-9.857,9.857Zm19.714-34.779-3.683,3.683a3.285,3.285,0,0,1-4.646-4.646l9.292-9.3a3.288,3.288,0,0,1,4.646,0l9.3,9.3a3.286,3.286,0,0,1-4.649,4.646l-3.683-3.683v15.065a3.286,3.286,0,0,1-6.571,0Z",
    transform: "translate(304.229 695.025)",
    fill: "#ff45b7",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenShareOnButton);
export default __webpack_public_path__ + "static/media/screenShareOnButton.d51b1aac75ac78701f51869fc9e2004e.svg";
export { ForwardRef as ReactComponent };